import { Card } from "antd";
import { Header } from "antd/lib/layout/layout";
import PageTop from "@root/modules/Sellers/Dashboard/components/PageTop/index";
import TableMemberList from "@modules/Members/components/TableMemberList";
import useTranslate from "@core/hooks/useTranslate";
interface Props {}

const breadcrumbList = [
  {
    label: "menu:members",
    url: "/admin/members",
  },
];

const MembersPage = (props: Props) => {
  const [t] = useTranslate();

  return (
    <>
      <Header className="header-page-top">
        <PageTop
          breadcrumbList={breadcrumbList}
          title={t("menu:members")}
          t={t}
        />
      </Header>
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: "80vh",
          }}
        >
          <div className="member-page">
            <TableMemberList t={t} />
          </div>
        </Card>
      </div>
    </>
  );
};

export default MembersPage;
